export default "__VITE_PUBLIC_ASSET__77141a79__"